import { TableCellTypes } from '@carboledger/ui';
import { makeLinkCell } from '@/components/common';
import { CUSTOMER_COLUMNS, CUSTOMER_SORT_FIELDS } from './customers.constants';

const canSort = (id) => Boolean(CUSTOMER_SORT_FIELDS[id]);

// Both S.No. and Customer name open the row's detail page, so both render through makeLinkCell.
const makeSerialLinkCell = (offset, onOpenCustomer) => {
  const renderLink = makeLinkCell(onOpenCustomer);
  const renderSerial = (ctx) => renderLink({ ...ctx, value: String(offset + ctx.rowIndex + 1) });
  return renderSerial;
};

export const buildCustomersColumns = (t, { serialOffset = 0, onOpenCustomer } = {}) =>
  [
    {
      id: CUSTOMER_COLUMNS.serialNo,
      header: t('FIELD_SERIAL_NO'),
      type: TableCellTypes.custom,
      width: 80,
      cell: makeSerialLinkCell(serialOffset, onOpenCustomer),
    },
    {
      id: CUSTOMER_COLUMNS.customerName,
      header: t('FIELD_CUSTOMER_NAME'),
      type: TableCellTypes.custom,
      width: 220,
      pinnable: true,
      cell: makeLinkCell(onOpenCustomer),
    },
    {
      id: CUSTOMER_COLUMNS.customerId,
      header: t('FIELD_CUSTOMER_ID'),
      type: TableCellTypes.text,
      width: 160,
    },
    {
      id: CUSTOMER_COLUMNS.shippingSiteCount,
      header: t('FIELD_SHIPPING_SITES'),
      type: TableCellTypes.text,
      width: 140,
    },
    {
      id: CUSTOMER_COLUMNS.primaryContact,
      header: t('FIELD_PRIMARY_CONTACT'),
      type: TableCellTypes.text,
      width: 280,
    },
    {
      id: CUSTOMER_COLUMNS.lastUpdated,
      header: t('FIELD_LAST_UPDATED'),
      type: TableCellTypes.text,
      width: 140,
    },
  ].map((column) => ({ ...column, sortable: canSort(column.id) }));
